import angular from 'angular';

export default function copyToClipboard() {
  return {
    restrict: 'A',
    link($scope, $element) {
      const sourceElement = $element[0].querySelector('[clipboard-copy-source]');
      const buttonElement = $element[0].querySelector('[clipboard-copy-button]');
      if (!sourceElement || !buttonElement) {
        throw 'You need to specify clipboard copy source and button';
      }

      const onCopyClick = () => {
        sourceElement.select();
        document.execCommand('copy');
      };

      const $buttonElement = angular.element(buttonElement);
      $buttonElement.on('click', onCopyClick);
      $buttonElement.on('$destroy', () => {
        $buttonElement.off('click', onCopyClick);
      });
    },
  };
}
